


























































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import AppConst from '../../../lib/appconst';
import Tools from '../../../lib/tools';
import QuickTable from "../../../components/table/table.vue";
import SelectDep from "../../../components/select/selectDep.vue";
@Component({
	name:'',
	components: {
		QuickTable,
		SelectDep
	}
})
export default class PaperManage extends AbpBase  {
    initData:any = {
        showModal: false,
        modelType:'detail',
    	searchData: {
    		AchieveName: '',
    		Author: '',
    		PeriodicalName: '',
    		BelongOrgId: null
    	},
        dicData: {
            allDictionary: {},
            bearerUnit: [],			// 单位
            secondOrgs: [],			// 二级部门
        },
        formData: {
        	id: '',
        	achieveName: '',
        	author: '',
        	periodicalName: '',
        	year: '',
        	volume: null,
        	stage: null,
        	pageRange: '',
        	publicationLevel: null,
        	belongOrgId: null,
        	secondBelongOrgId: null,
        	firstUnitName: null,
        	signatureSecondUnit: '',
        	signatureThirdUnit: ''
        },
        validate: {
        	achieveName: 	[{ required: true, message: '请填写论文名称', trigger: 'blur' }],
        	author: 		[{ required: true, message: '请填写作者', trigger: 'blur' }],
        	periodicalName: [{ required: true, message: '请填写期刊(会议)名称', trigger: 'blur' }],
        	year: 			[{ required: true, type: 'date', message: '请选择年份', trigger: 'change' }],
        	volume: 		[{ required: true, type: 'number', message: '请填写卷', trigger: 'blur' }],
        	stage: 			[{ required: true, type: 'number', message: '请填写期', trigger: 'blur' }],
        	pageRange: 		[{ required: true, message: '请填写起止页码', trigger: 'blur' }],
        	publicationLevel: [{ required: true, type: 'number', message: '请选择论文级别', trigger: 'change' }],
        	belongOrgId: 	[{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }],
        	firstUnitName: 		[{ required: true, type: 'string', message: '请选择第一署名单位', trigger: 'blur' }]
        },
        columns: [
        	{
                title: '序号',
                key: 'achieveCode',
                align: 'center',
                width: 118
            },
            {
                title: '论文名称',
                key: 'achieveName',
                align: 'center',
                minWidth: 280,
                render: (h:any, params:any)=>{
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'text'
                            },
                            style: {
                                color: '#57a3f3',
                                cursor: 'pointer'
                            },
                            on: {
                                click: () => {
                                    this.showModel('detail', params.row);
                                }
                            }
                        }, params.row.achieveName)
                    ])
                }
            },
            {
                title: '作者',
                key: 'author',
                align: 'center',
                width: 100
            },
            {
                title: '期刊（会议）名称',
                key: 'periodicalName',
                align: 'center',
                width: 220
            },
            {
                title: '年',
                key: 'year',
                align: 'center',
                width: 80
            },
            {
                title: '卷',
                key: 'volume',
                align: 'center',
                width: 80
            },
            {
                title: '期',
                key: 'stage',
                align: 'center',
                width: 80
            },
            {
                title: '起止页码',
                key: 'pageRange',
                align: 'center',
                width: 98
            },
            {
                title: '论文级别',
                key: 'publicationLevelDesc',
                align: 'center',
                width: 110
            },
            {
                title: '部门',
                key: 'belongOrg',
                align: 'center',
                width: 150,
                render: (h:any, params:any) => {
                	let orgstr = '';
                	if(params.row.belongOrg) {
                		orgstr = params.row.belongOrg.displayName;
                	}
                	if(params.row.belongOrg && params.row.secondBelongOrg) {
                		orgstr += ' / '
                	}
                	if(params.row.secondBelongOrg) {
                		orgstr += params.row.secondBelongOrg.displayName;
                	}
                	return h('Col', orgstr);
                }
            },
            {
                title: '第一署名单位',
                key: 'firstUnitName',
                align: 'center',
                width: 198,
                render: (h:any, params:any) => {
                	return h('Col', params.row.firstUnitName ? params.row.firstUnitName : '');
                }
            },
            {
                title: '操作',
                key: 'action',
                align: 'center',
                width: 128,
                render: (h:any, params:any)=>{
                    return h('span', [
                		h('Button', {
                			props: {
                				type: 'success',
                				size: 'small'
                            },
                            style: {
                                display: params.row.canEdit?'':'none'
                            },
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										if(k == 'year'){
											this.initData.formData[k] = params.row.year > 1000 ? params.row[k].toString() : '';
										}else if(k == 'belongOrgId'){
											this.initData.formData[k] = params.row.belongOrg ? params.row.belongOrg.id : null;
										}else if(k == 'secondBelongOrgId'){
											this.initData.formData[k] = params.row.secondBelongOrg ? params.row.secondBelongOrg.id : null;
										// }else if(k == 'firstUnitName'){
										// 	this.initData.formData[k] = params.row.unit ? params.row.unit.id : null;
										}else{
											this.initData.formData[k] = params.row[k];
										}
                                    }
                                    this.initData.modelType = 'edit';
									this.initData.showModal = true;
								}
							}
                		}, '编辑'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                                marginLeft: '10px',
                                display: params.row.canDelete?'':'none'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
        ]
    }
    // 详情
    showModel(type: any,data: any) {
        this.initData.formData = Object.assign({},data);
        this.initData.formData.belongOrgId = data.belongOrg ? data.belongOrg.id : null;
        this.initData.formData.secondBelongOrgId = data.secondBelongOrg ? data.secondBelongOrg.id : null;
        // this.initData.formData.firstUnitName = this.initData.formData.unit ? data.unit.id : null;
        this.initData.formData.year = this.initData.formData.year ? (data.year).toString() : null;
        
        this.initData.showModal = true;
        this.initData.modelType = type;
    }
    //字典
    async GetDic() {
        //所有字典
        await this.$store.dispatch('project/GetAllDictionary')    
        //单位字典
        await this.$store.dispatch('project/GetbearerUnit')    
        //部门字典
        await this.$store.dispatch('project/GetbearerOrg')
        this.$store.state.project.allDictionary.map((item:any) => {
            this.$set(this.initData.dicData.allDictionary, item.key, item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            }));
        });
        this.initData.dicData.bearerUnit = this.$store.state.project.bearerUnitId;
        //当前登录用户信息
        this.$store.dispatch('session/init');
        this.initData.dicData.userInfo = this.$store.state.session.user;
    }
    GetData() {
        (this as any).$refs.table.GetData();
   	}
    @Watch('initData.formData.belongOrgId', {deep: true})
    //二级部门
    async GetSecondBelongOrg(id:any){
        if(!id) return;
        Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?Id='+id).then((res:any)=>{
            this.initData.dicData.secondOrgs = res.data.result.map((item:any) => {
	        	return {
	        		label: item.displayName,
	        		value: item.id
	        	}
	        });
        })
    }
    // 打开新增弹窗
    handleNewAdd() {
    	try{
    		let userInfo = this.initData.dicData.userInfo;
    		this.initData.formData.belongOrgId = userInfo.organization.id;
    		// this.initData.formData.firstUnitName = userInfo.unit.id;
    	}catch(e){
    		//TODO handle the exception
        }
        this.initData.modelType = 'add';
    	this.initData.showModal = true;
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'year') {
							params[k] = Tools.formatDate(datas[k], 'yyyy');
						}else{
							params[k] = datas[k];
						}
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/Achieve/UpdatePaperAsync', params).then((res:any)=>{
		                this.$Message.success('编辑成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/Achieve/CreatePaperAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    // 删除
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此论文登记？',
            onOk: () => {
                Ajax.delete('/api/services/app/Achieve/DeleteAwardPrizeAsync?Id='+id).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    //合同切换
    SwitchContract(name:any) {
        this.$router.push({
            name: name
        })
    }
    //初始化
    mounted() {
        this.GetDic();
    }
}
